export default __webpack_public_path__ + "static/media/3.3bae9419.jpg";